import axios from "@/api/axiosInstance";
import {
  UpdateRecurringEmailSubscriptionRequest,
  UpdateRecurringEmailSubscriptionResponse,
} from "./types";

export const updateRecurringEmailSubscription = async (
  employeeUuid: string,
  recurringEmail: string,
  requestData: UpdateRecurringEmailSubscriptionRequest,
): Promise<UpdateRecurringEmailSubscriptionResponse> => {
  const response = await axios.put<UpdateRecurringEmailSubscriptionResponse>(
    `/api/private/admin/employees/${employeeUuid}/recurring-emails/${recurringEmail}`,
    requestData,
  );
  return response.data;
};
